import { render, staticRenderFns } from "./termsConditionTicket.vue?vue&type=template&id=1d355a2e"
import script from "./termsConditionTicket.vue?vue&type=script&lang=js"
export * from "./termsConditionTicket.vue?vue&type=script&lang=js"
import style0 from "./termsConditionTicket.vue?vue&type=style&index=0&id=1d355a2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports